import {Component, Input, OnInit} from '@angular/core';
import { postMessageToIframe } from 'src/app/_core/_function/postMessageToIframe';

// import "@lottiefiles/lottie-player";
@Component({
    selector: 'app-wind-rose',
    templateUrl: './wind-rose.component.html',
    styleUrls: ['./wind-rose.component.scss']
})
export class WindRoseComponent implements OnInit {
    arayAirDirections = ['n', 'ne', 'e', 'se', 's', 'sw', 'w', 'nw'];
    // arayAirDirections = ['n', 'nw', 'w', 'sw', 's', 'se', 'e', 'ne'];
    @Input()
    public curSceneName: string = '';

    @Input()
    public sceneTitleArray: any = [];

    iframeElement: any;
    activeRose: boolean = false;
    message: any;
    activateRose: boolean = true;
    roseTitleArray: any = [];
    notActiveRoseDirections: any = [];
    desktopResolution: boolean = true;

    constructor() {
    }

    ngOnInit(): void {
        this.activateRoseF();
        if (window.innerWidth < 1200) {
            this.desktopResolution = false;
        }
    }

    activeRoseF(bool) {
        // this.activeRose = true;
        // event.stopPropagation();
    }


    nextDirF() {
        if (this.curSceneName.includes("_")) {
            const dir = this.curSceneName.split('_').pop();
            console.log(dir);
            const index = this.roseTitleArray.findIndex((direction) => direction === dir);
            let nextDirection = this.roseTitleArray[0]
            if (index !== this.roseTitleArray.length - 1) {
                nextDirection = this.roseTitleArray[index + 1];
            }
            this.changeDirection(nextDirection);
        }
    }

    changeDirection(dir) {
        if (this.curSceneName === 'scene_' + dir) {
            return;
        }
        const curDir = 'scene_' + dir;
        this.curSceneName = curDir;
        const data = {
            scene: curDir, // pano ID
            autorotate: true,
        };

        postMessageToIframe(data);
    }

    activateRoseF() {
        this.arayAirDirections.forEach(title => {
            this.notActiveRoseDirections.push(title);
            this.sceneTitleArray.forEach(title2 => {
                if (title === title2) {
                    this.roseTitleArray.push(title2);
                    let index = this.notActiveRoseDirections.indexOf(title2);
                    this.notActiveRoseDirections.splice(index, 1);
                }
            });
        });
        if (this.roseTitleArray.length > 1) {
            this.activateRose = true;
        } else {
            this.activateRose = false;
        }
    }

}
